export default __webpack_public_path__ + "static/media/pizzeria_camion.ae1a7c95.png";